module.exports = __webpack_public_path__ + "img/WhatsApp Image 2020-06-24 at 3.46.32 PM(1).73c743df.jpeg";